module.exports = __webpack_public_path__ + "img/az.e9dc94be.svg";